module.exports = new __parcel__URL__("Optum_Here4TN.91061bd9.png").toString();